// import Meta from 'vue-meta';
import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import { PROFILE_TYPES } from '@/utils/enums';
import store from '@/store';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                top: 80,
                behavior: 'smooth',
            };
        }

        if (savedPosition) {
            return savedPosition;
        }

        return {
            top: 0,
        };
    },
});

let isFirstLoad = true;

function buildRedirect(to) {
    if (to.path === '/') return undefined;
    return to.fullPath.startsWith('/') ? to.fullPath : '/';
}

async function beforeEach(to) {
    const requiredAuth = to.meta?.auth ?? false;
    const allowRoles = to.meta?.allowRoles;

    if (isFirstLoad) {
        isFirstLoad = false;

        try {
            await store.dispatch('auth/checkAuth');
        } catch (error) {
            if (requiredAuth) {
                return { name: 'login', query: { redirect: buildRedirect(to) } };
            }
        }
    }

    const isAuthenticated = store.getters['auth/isAuthenticated'];
    const userRoles = store.getters['profile/userRoles'] ?? [];

    if (!requiredAuth && isAuthenticated && to.name !== 'device-blocked') {
        return { name: 'home' };
    }

    if (requiredAuth) {
        if (!isAuthenticated) {
            return { name: 'login', query: { redirect: buildRedirect(to) } };
        }

        if (allowRoles) {
            const hasRole = allowRoles.some((role) => userRoles.includes(role));

            if (!hasRole) {
                return { name: '403' };
            }
        }

        const isDeveloperRoute = to.matched.some((r) => r.path?.startsWith('/developer'));

        if (isDeveloperRoute) {
            const isDeveloperQualified = store.getters['profile/isDeveloperQualified'];

            if (!isDeveloperQualified && to.name !== 'developer.home') {
                return { name: 'qualification', params: { type: PROFILE_TYPES.DEVELOPER } };
            }
        }
    }
}

router.beforeEach(beforeEach);

router.afterEach((to) => {
    if (to.meta?.title) {
        document.title = to.meta.title + ' · Yampi Parceiros';
    } else {
        document.title = 'Yampi Parceiros';
    }
});

export default router;
